module.exports = __webpack_public_path__ + "static/media/S14_B.88e8f487.png";